export default {
  // TODO: Rename keys with "merchant_bo" prefix instead of "international_onboarding_"
  // since it's used both in the IO and on the Options page - MCC-3341
  carrier: {
    id: 'international_onboarding_shipping_carrier',
    defaultMessage: 'Carrier',
  },
  category: {
    id: 'international_onboarding_shipping_category',
    defaultMessage: 'Category',
  },
  allCategories: {
    id: 'international_onboarding_shipping_all_categories',
    defaultMessage: 'All categories',
  },
  addFormMarketSelectLabel: {
    id: 'merchant_bo_shipping_methods_form_select_market_label',
    defaultMessage: 'Market',
  },
  cost: {
    id: 'international_onboarding_shipping_cost',
    defaultMessage: 'Cost ({currency})',
  },
  costDefault: {
    id: 'merchant_bo_shipping_cost_default',
    defaultMessage: 'Cost',
  },
  addShippingFormCostDescription: {
    id: 'merchant_bo_shipping_methods_form_cost_description',
    defaultMessage:
      'You need at least one free delivery option for each category in order for your listing to be online.',
  },
  shippingDelay: {
    id: 'international_onboarding_shipping_shipping_delay',
    defaultMessage: 'Shipping delay (in number of hours)',
  },
  shippingDelayExplanation: {
    id: 'international_onboarding_shipping_shipping_delay_explanation',
    defaultMessage: 'Shipping delay = preparation time + transport time.',
  },
  shippingDateExplanation: {
    id: 'international_onboarding_shipping_shipping_date_explanation',
    defaultMessage:
      "Monday to Friday, excluding public holidays (customer's time zone).",
  },
  cancel: {
    id: 'international_onboarding_shipping_cancel',
    defaultMessage: 'Cancel',
  },
  required: {
    id: 'bo_merchant_form_required_field_error',
    defaultMessage: 'This field is required',
  },
  minShippingDelay: {
    id: 'bo_merchant_shipping_min_shipping_delay',
    defaultMessage: 'The minimum shipping delay is {min}h',
  },
  maxShippingDelay: {
    id: 'bo_merchant_shipping_max_shipping_delay',
    defaultMessage: 'The maximum shipping delay is {max}h',
  },
  minShippingCost: {
    id: 'bo_merchant_shipping_min_shipping_cost',
    defaultMessage: "The shipping cost can't be negative",
  },
  delayMustBeInteger: {
    id: 'bo_merchant_shipping_delay_must_be_integer',
    defaultMessage: 'The shipping delay must be an integer number',
  },
  add: {
    id: 'international_onboarding_shipping_add_this_shipping_method',
    defaultMessage: 'Add this shipping method',
  },
  edit: {
    id: 'international_onboarding_shipping_edit_this_shipping_method',
    defaultMessage: 'Edit this shipping method',
  },
} as const
